import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Input } from "@/components/ui/input";
import { FormElement } from "../types";

interface DateInputProps {
  element: FormElement;
  value: string;
  onChange: (value: string) => void;
}

export const DateInput = ({ element, value, onChange }: DateInputProps) => {
  const [date, time] = value.split('T');

  const handleDateChange = (newDate: string) => {
    onChange(time ? `${newDate}T${time}` : newDate);
  };

  const handleTimeChange = (newTime: string) => {
    onChange(date ? `${date}T${newTime}` : newTime);
  };

  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <Label htmlFor={`${element.id}-date`}>
          {element.title}
          {element.required && <span className="text-red-500 ml-1">*</span>}
        </Label>
        <Input
          id={`${element.id}-date`}
          type="date"
          value={date}
          onChange={(e) => handleDateChange(e.target.value)}
          required={element.required}
        />
      </div>
      {element.dateConfig?.timeSlots && (
        <div className="space-y-2">
          <Label htmlFor={`${element.id}-time`}>Select Time</Label>
          <Select value={time} onValueChange={handleTimeChange}>
            <SelectTrigger id={`${element.id}-time`}>
              <SelectValue placeholder="Select a time slot" />
            </SelectTrigger>
            <SelectContent>
              {element.dateConfig.timeSlots.map((slot, index) => (
                <SelectItem 
                  key={index} 
                  value={`${slot.startTime}-${slot.endTime}`}
                >
                  {slot.startTime} - {slot.endTime}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      )}
    </div>
  );
};